var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userService"},[_c('van-nav-bar',{staticClass:"nav",attrs:{"title":"隐私协议","left-arrow":""},on:{"click-left":_vm.leftReturn}}),_c('div',{staticClass:"placeholder"}),_c('div',{attrs:{"id":"details"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }